import { ReactNode } from "react"
import { WEB_LINKS } from "../../../../../constants/links"
import { theme } from "../../../../../styles/stitches.config"

export function GDPRLink(props: { children: ReactNode }) {
  const { children } = props
  return (
    <a
      href={WEB_LINKS.termsAndConditions}
      target="_blank"
      rel="noreferrer"
      style={{ fontWeight: theme.fontWeights.bold.value, color: theme.colors.primary.value }}
    >
      {children}
    </a>
  )
}
